// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Status of the entitlement
 * @export
 */
export const EntitlementStatus = {
  Inactive: 'inactive',
  Active: 'active',
  Void: 'void',
} as const;
export type EntitlementStatus =
  (typeof EntitlementStatus)[keyof typeof EntitlementStatus];

export function instanceOfEntitlementStatus(value: any): boolean {
  for (const key in EntitlementStatus) {
    if (Object.prototype.hasOwnProperty.call(EntitlementStatus, key)) {
      if (EntitlementStatus[key as keyof typeof EntitlementStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EntitlementStatusFromJSON(json: any): EntitlementStatus {
  return EntitlementStatusFromJSONTyped(json, false);
}

export function EntitlementStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EntitlementStatus {
  return json as EntitlementStatus;
}

export function EntitlementStatusToJSON(value?: EntitlementStatus | null): any {
  return value as any;
}

export function EntitlementStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EntitlementStatus {
  return value as EntitlementStatus;
}
